// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3ttzO","header":"MergedInvoice_header__1uThn"};